import "../../pages/new/new.scss"

import React, { useState,useEffect } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getBatches } from '../../services/studentService';

export const AddTerm = () => {
    const { termId } = useParams();
    const [isChecked, setIsChecked] = useState(false);

    // Handle checkbox change
    const handleCheckboxChange = () => {
      setIsChecked(!isChecked);
      setTerm({ ...term, ['active']: !isChecked });
    };

    const [term, setTerm] = useState({
        name: '',
        degreeId: '',
        programId: '',
        batch: '',
        startDate: '',
        endDate: '',
        midSemDate: '',
        endSemDate: '',
        submissionDate:'',
        active:''
    });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const [batches, setBatches] = useState([]);
    const [degrees, setDegrees] = useState([]);
    const [programs, setPrograms] = useState([]);

    const fetchBatches = async () => {
        try {
            const batchdata = await getBatches();
            setBatches(batchdata.data);
        } catch (error) {
            console.error('Error fetching batches:', error);
        }
    };
    const fetchDegreesAndPrograms = async () => {
        try {
            const [degreesRes, programsRes] = await Promise.all([
                axiosInstance.get('/getAllDegrees'),
                axiosInstance.get('/getAllPrograms'),
            ]);
            setDegrees(degreesRes.data?.data || []);
            setPrograms(programsRes.data?.data || []);
        } catch (error) {
            console.error('Error fetching degrees/programs:', error);
        }
    };
    useEffect(() => {
        fetchBatches();
        fetchDegreesAndPrograms();
    }, []);
    const handleDegreeChange = (event) => {
        const degreeId = event.target.value;
        setTerm(term => ({ ...term, degreeId, programId: '' }));
    };
    const filteredPrograms = programs.filter(
        p => !term.degreeId || String(p.degreeId) === String(term.degreeId)
    );

    const termNames = [
        "Term IV",
            "Term V",
            "Term VI"
            ];

    const fetchTerm = async (id) => {
        try {
            const response = await axiosInstance.get(`/getTermById?id=${id}`);
          //  console.log(response.data.data)
            setTerm(response.data.data);
            setIsChecked(response.data.data.active);
            
        } catch (error) {
            console.error('Error fetching instructor:', error);
        }
    };
    useEffect(() => {
        if (termId) {
            const path = window.location.pathname;
            if(path.includes('edit-term')){
                setEditMode(true);
            }
            else if(path.includes('view-term')){
                setViewMode(true);
            }
            fetchTerm(termId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false); // Set mode to add if no courseId is present
            setViewMode(false);            
        }
    }, [termId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name' && value !== 'Term IV') {
            setTerm({ ...term, name: value || '', midSemDate: '', endSemDate: '' });
        } else {
            setTerm({ ...term, [name]: value || ''});
        }
        setErrors({ ...errors, [name]: '' });
    };

    const goBack = (e) => {
        navigate('/terms');
    };

    const validateForm = () => {
        const newErrors = {};
        if (!term.name || !term.name.trim()) {
            newErrors.name = 'term name is required';
        }
        if (!term.startDate || !term.startDate.trim()) {
            newErrors.startDate = 'term start date is required';
        }
        if (!term.endDate || !term.endDate.trim()) {
            newErrors.endDate = 'term end date is required';
        }
        if(term.endDate){
            const endDate = new Date(term.endDate);
            const today = new Date();
            if(term.active && endDate < today){
                newErrors.active = 'term end date must be greater then current date';
            }
            if(term.startDate){
                const startDate = new Date(term.startDate);
                if(startDate>endDate){
                    newErrors.endDate = 'term end date must be greater then start date';
                }
                if(term.midSemDate){
                    const midSemDate = new Date(term.midSemDate);
                    if(midSemDate>endDate || midSemDate<startDate){
                        newErrors.midSemDate = 'midSemDate must be between start date and end date';
                    }
                }
                if(term.endSemDate){
                    const endSemDate = new Date(term.endSemDate);
                    if(endSemDate>endDate || endSemDate<startDate){
                        newErrors.endSemDate = 'endSemDate must be between start date and end date';
                    }
                }
                if(term.submissionDate){
                    const submissionDate = new Date(term.submissionDate);
                    if(submissionDate>endDate || submissionDate<startDate){
                        newErrors.submissionDate = 'submissionDate must be between start date and end date';
                    }
                }
                
            }
        }
       
       
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
       // console.log(term);
        if (!validateForm()) return;
       // console.log("inside submit");
        var response='';
        try {
            if(viewMode){
                navigate('/terms');
            }
            else if (editMode) {
                // Update course if in edit mode
                response = await axiosInstance.put('/terms', term,{showToastOnResponse: true});
            }
            else{
                response = await axiosInstance.post('/terms', term,{showToastOnResponse: true});
            
            }
           // console.log(response);
            navigate('/terms');
            
        } catch (error) {
            console.log('Error saving term. Please try again later.');
            console.log(error);
        }
    };


    return (
        <div>
        <div className="top">
        <h1>{editMode? 'Edit term' : viewMode? 'View term': 'Add term'}</h1>
      </div>
      <div className="bottom">
        <div className="left"></div>
        <div className="right">
        <form onSubmit={handleSubmit}>
           
            {/*}
            <div className="formInput">
              <label>Term name</label>
              <input type="text" 
              name="name"
              value={term.name}
              onChange={handleChange}
              readOnly={viewMode}
              className={errors.name ? 'error' : ''}/>
              {errors.name && <div className="error-text">{errors.name}</div>}
            </div>          
                */}
                <div className="formInput">
  <label>Term name</label>
  <select
    name="name"
    value={term.name}
    onChange={handleChange}
    disabled={viewMode}
    className={errors.name ? 'error' : ''}
  >
    <option value="">Select Term</option>
    {termNames.map((t) => (
      <option key={t} value={t}>{t}</option>
    ))}
  </select>
  {errors.name && <div className="error-text">{errors.name}</div>}
</div>

                <div className="formInput">
                    <label>Batch </label>
                    <select id="styled-dropdown"
                        name="batch"
                        disabled={viewMode}
                        value={term.batch || ''}
                        onChange={handleChange}
                    >
                        <option value="">All Batches</option>
                        {batches && batches.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="formInput">
                    <label>Degree </label>
                    <select id="styled-dropdown"
                        name="degreeId"
                        disabled={viewMode}
                        value={term.degreeId || ''}
                        onChange={handleDegreeChange}
                    >
                        <option value="">All Degrees</option>
                        {degrees && degrees.map(option => (
                            <option key={option.id} value={option.id}>
                                {option.degreeName}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="formInput">
                    <label>Program </label>
                    <select id="styled-dropdown"
                        name="programId"
                        disabled={viewMode}
                        value={term.programId || ''}
                        onChange={handleChange}
                    >
                        <option value="">All Programs</option>
                        {filteredPrograms.map(option => (
                            <option key={option.id} value={option.id}>
                                {option.programName}
                            </option>
                        ))}
                    </select>
                </div>

            <div className="formInput">
            <label>Term Start Date</label>
            <input
                type="date"
                id="startDate"
                name="startDate"
                readOnly={viewMode}
                value={term.startDate}
                onChange={handleChange}
            />
            {errors.startDate && <div className="error-text">{errors.startDate}</div>}
        </div>

        <div className="formInput">
            <label>Term End Date</label>
            <input
                type="date"
                id="endDate"
                name="endDate"
                readOnly={viewMode}
                value={term.endDate}
                onChange={handleChange}
            />
            {errors.endDate && <div className="error-text">{errors.endDate}</div>}
        </div>

        {term.name === 'Term IV' && <div className="formInput">
            <label>Project Particular Date</label>
            <input
                type="date"
                id="midSemDate"
                name="midSemDate"
                readOnly={viewMode}
                value={term.midSemDate}
                onChange={handleChange}
            />
            {errors.midSemDate && <div className="error-text">{errors.midSemDate}</div>}
        </div>}

        {term.name === 'Term IV' && <div className="formInput">
            <label>Project Proposal Submission Date</label>
            <input
                type="date"
                id="endSemDate"
                name="endSemDate"
                readOnly={viewMode}
                value={term.endSemDate}
                onChange={handleChange}
            />
            {errors.endSemDate && <div className="error-text">{errors.endSemDate}</div>}
        </div>}

        <div className="formInput">
            <label>End Term Report Submission Date</label>
            <input
                type="date"
                id="submissionDate"
                name="submissionDate"
                readOnly={viewMode}
                value={term.submissionDate}
                onChange={handleChange}
            />
            {errors.submissionDate && <div className="error-text">{errors.submissionDate}</div>}
        </div>

        <div className="formInput" style={{ width: '100%' }}>
            <label>Is current term</label>
            <input
                type="checkbox"
                checked={isChecked}
                name="active"
                onChange={handleCheckboxChange}
                disabled={viewMode}
                value={term.active}
        />
                        {errors.active && <div className="error-text">{errors.active}</div>}
        </div>


        <div className="buttons">
           {!viewMode && <button type="submit">{editMode ? 'Update' : 'Save'}</button>}
           <button type="button" onClick={goBack}>Back</button>
           </div>
           </form>
          </div>
          </div>
          </div>
    );
};


